import { OrderApi } from '@/api/order.api';
import { CreateStartOperation } from '@/models/proposal-order.model';
import { LoadingService } from '@/services/loading.service';
import { NotificationService } from '@/services/notification.service';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface DialogData {
  proposalID: string;
  researchViabilityArray: any;
  inventoryViabilityArray: any;
  restockingViabilityArray: any;
}

@Component({
  selector: 'app-dialogStartOperation',
  templateUrl: './dialogStartOperation.component.html',
  styleUrls: ['./dialogStartOperation.component.scss'],
})
export class DialogStartOperationComponent {

  form!: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogStartOperationComponent>,
    private formBuilder: FormBuilder,
    private orderApi: OrderApi,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.initializeForm();
  }

  onRightButton() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  keypressDate(event: KeyboardEvent) {
    event.preventDefault();
    return;
  }

  private initializeForm() {
    this.form = this.formBuilder.group({
      suggestedStartDate: ['', [Validators.required]],
    });
  }

  updateViabilities(form: FormGroup) {
    this.loadingService.show();
    const newValues = {
      suggestedStartDate: form.get('suggestedStartDate')!.value,
    };
    if (this.data?.researchViabilityArray) {
      this.data?.researchViabilityArray.forEach((store: any) => {
        store.startDate = newValues.suggestedStartDate;
      });
    }
    if (this.data?.inventoryViabilityArray) {
      this.data?.inventoryViabilityArray.forEach((store: any) => {
        store.startDate = newValues.suggestedStartDate;
      });
    }
    if (this.data?.restockingViabilityArray) {
      this.data?.restockingViabilityArray.forEach((store: any) => {
        store.startDate = newValues.suggestedStartDate;
      });

      const newDataViability = new CreateStartOperation(
        this.data.proposalID,
        this.data.researchViabilityArray,
        this.data.inventoryViabilityArray,
        this.data.restockingViabilityArray
      );

      this.orderApi.createOperationStart(newDataViability).then(() => {
        this.loadingService.hide();
        this.onRightButton();
        this.notificationService.showSuccessMessage("Início de operação salva com sucesso");
      }).catch((error) => {
        this.loadingService.hide();
      });
    }
  }

  massEdit() {
    this.updateViabilities(this.form);

  }

  isSaveUpdateButtonEnabled(): boolean {

    if (this.form.invalid) {
      return false;
    } else {
      return true;
    }
  }
}
